import { Component } from '@angular/core';
import { AnyoTableComponent } from 'projects/app-core/src/app/models/AnyoTableComponent';
import { ToastService } from 'projects/app-core/src/app/services/toastr.service';
import { AuthService } from 'projects/app-core/src/auth/auth.service';
import { EmailTemplateGridResponseData } from '../../../models/email-templates/emailTemplateGridResponse';
import {
  EmailTemplateFilter,
  EmailTemplateGridRequest,
} from '../../../models/email-templates/emailTemplatesGridRequest';
import { EmailTemplatesService } from '../../../services/email-templates.service';
import { lastValueFrom } from 'rxjs';
import { IAnyoError } from 'projects/app-core/src/models/errorModal';
import { UtilsService } from 'projects/app-core/src/service/utils.service';
import { EmailTemplateStatus } from '../../../models/email-templates/emailTemplate';

interface CheckBoxOptions {
  label: string;
  value: string;
  checked: boolean;
}

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrl: './list.component.scss',
})
export class ListComponent extends AnyoTableComponent<
  EmailTemplateGridResponseData,
  EmailTemplateGridRequest
> {
  globalSearchInput = '';
  constructor(
    protected override auth: AuthService,
    protected override toastService: ToastService,
    private emailTemplateService: EmailTemplatesService,
    public utils: UtilsService,
  ) {
    super(auth, toastService);
  }
  public readonly EmailTemplateStatus = EmailTemplateStatus;
  tagsCheckBoxOptions: CheckBoxOptions[] = [];
  statusCheckBoxOptions: CheckBoxOptions[] = [];
  isVisible: boolean = false;

  tagFilter($event: string[]) {
    if ($event && $event.length) {
      if (!this.gridRequest!.filters) {
        this.gridRequest!.filters = {
          [EmailTemplateFilter.TAGS]: [],
        };
      }
      this.gridRequest!.filters!.TAGS = $event;
    }
  }

  statusFilter($event: string[]) {
    if ($event && $event.length) {
      if (!this.gridRequest!.filters) {
        this.gridRequest!.filters = {
          [EmailTemplateFilter.STATUS]: [],
        };
      }
      this.gridRequest!.filters!.STATUS = $event;
    }
  }

  onToggleVisibility() {
    this.getData();
  }

  override async getData(): Promise<void> {
    this.pageLoading = true;
    this.data = [];

    try {
      if (!this.gridRequest.filters) {
        this.gridRequest.filters = {};
      }
      this.gridRequest.filters.IS_VISIBLE = [
        !this.isVisible ? 'true' : 'false',
      ];
      const response = await lastValueFrom(
        this.emailTemplateService.emailTemplatesGridlist(this.gridRequest),
      );

      if (response) {
        this.data = response.data;
        this.data.forEach((data) => {
          data.tagsWithColor = data.tags.map((data) => {
            return {
              data: this.utils.fromSnakeCase(data),
              color: this.utils.getRandomColor(),
            };
          });
        });
        this.tagsCheckBoxOptions = response.filterOptions?.tags.map((data) => {
          if (this.gridRequest.filters?.TAGS?.includes(data)) {
            return {
              label: this.utils.fromSnakeCase(data),
              value: data,
              checked: true,
            };
          } else {
            return {
              label: this.utils.fromSnakeCase(data),
              value: data,
              checked: false,
            };
          }
        });
        this.statusCheckBoxOptions = response.filterOptions?.status.map(
          (data) => {
            if (this.gridRequest.filters?.STATUS?.includes(data)) {
              return {
                label: this.utils.convertToTitleCase(data),
                value: data,
                checked: true,
              };
            } else {
              return {
                label: this.utils.convertToTitleCase(data),
                value: data,
                checked: false,
              };
            }
          },
        );
        this.totalCount = response.totalRecords;
      }
    } catch (error: unknown) {
      const errorBody = error as { error: IAnyoError };
      this.toastService.showAnyoErrorToast(errorBody.error.description);
    } finally {
      this.pageLoading = false;
    }
  }

  searchGlobal() {
    this.gridRequest.globalSearch = [this.globalSearchInput];
    this.getData();
  }

  override async resetFilter(): Promise<void> {
    this.globalSearchInput = '';
    this.dateRangeColumn = [];
    this.isVisible = false;
    this.gridRequest = {
      page: this.pageNo,
      pageSize: this.pageSize,
      export: false,
    };
    await this.getData();
  }

  navigateToLogs(templateId: string) {
    window.open(`/email-templates/logs?templateId=${templateId}`, '_blank');
  }
}
